export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS 2023.707f425c.pdf";